import { useTranslation } from 'react-i18next';

/**
 * EAA-1817 → EAA-1837: the empty/loading states the "Liên kết vai trò" table
 * needs. `NoStandardRolesEmptyState` and `RoleMapLoadingSkeleton` are carried
 * over from the coverage board (same cause, same copy); the "app not approved"
 * state went away with the per-app editor panel — a table has no selected app
 * to be unapproved. `RoleMapNoRowsEmptyState` and `RoleMapFilteredEmptyState`
 * are new and mirror `accounts/AccountsEmptyState.tsx`'s two-state split
 * (nothing here yet vs. nothing matches the filters).
 */

export function NoStandardRolesEmptyState({ onCreateLevel }: { onCreateLevel: () => void }) {
    const { t } = useTranslation();
    return (
        <div className="rm-empty">
            <span className="rm-empty__title">
                {t('console.roleMap.emptyStates.noStandardRolesTitle')}
            </span>
            <p className="rm-empty__desc">
                {t('console.roleMap.emptyStates.noStandardRolesDesc')}
            </p>
            <button type="button" className="rm-empty__cta" onClick={onCreateLevel}>
                {t('console.roleMap.emptyStates.createLevelCta')}
            </button>
        </div>
    );
}

export function RoleMapNoRowsEmptyState({
    scopeLabel,
    canAdd,
    onAdd,
}: {
    scopeLabel: string;
    canAdd: boolean;
    onAdd: () => void;
}) {
    const { t } = useTranslation();
    return (
        <div className="rm-empty">
            <span className="rm-empty__title">
                {t('console.roleMap.emptyStates.noRowsTitle', { scopeLabel })}
            </span>
            <p className="rm-empty__desc">{t('console.roleMap.emptyStates.noRowsDesc')}</p>
            {canAdd && (
                <button type="button" className="rm-empty__cta" onClick={onAdd}>
                    {t('console.roleMap.emptyStates.addLinkCta')}
                </button>
            )}
        </div>
    );
}

export function RoleMapFilteredEmptyState({ onClear }: { onClear: () => void }) {
    const { t } = useTranslation();
    return (
        <div className="rm-empty">
            <span className="rm-empty__title">
                {t('console.roleMap.emptyStates.filteredTitle')}
            </span>
            <p className="rm-empty__desc">{t('console.roleMap.emptyStates.filteredDesc')}</p>
            <button type="button" className="rm-empty__cta" onClick={onClear}>
                {t('console.roleMap.emptyStates.clearFiltersCta')}
            </button>
        </div>
    );
}

export function RoleMapLoadingSkeleton() {
    const { t } = useTranslation();
    return (
        <div className="rm-skel-card" role="status" aria-live="polite">
            <span className="portal-sr-only">{t('console.roleMap.emptyStates.srLoadingText')}</span>
            <span className="rm-skel-title" />
            {[0, 1, 2].map((row) => (
                <div className="rm-skel-row" key={row}>
                    <span className="rm-skel-cell rm-skel-cell--first" />
                    <span className="rm-skel-cell" />
                    <span className="rm-skel-cell" />
                    <span className="rm-skel-cell" />
                    <span className="rm-skel-cell" />
                </div>
            ))}
        </div>
    );
}
